import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { ClassroomQuizSession } from '../../../../Domain/ClassroomQuiz';
import { useQuizContext } from '../../../../Context/QuizContext';
import { QUIZ_SUB_ROUTES } from '../../constant';

import GradedExamResultView from './GradedExamResult.view';

const GradedExamResult = ({ onEndQuiz }) => {
  const {
    metadata: { maxAttempts, fullScore, passingScore },
    variant,
    timeSpent,
    openCourseReviewModal,
    isLastSubsectionInCourse,
  } = useQuizContext();

  const history = useHistory();
  const match = useRouteMatch();

  const { examId, examSessionId: paramExamSessionId } = match.params;

  const handleSeeReport = (reportId, roundIndex) => {
    history.push(`${QUIZ_SUB_ROUTES.SOLUTION.getPath(examId, reportId, roundIndex)}`);
  };

  return (
    <ClassroomQuizSession>
      {({ quizSessions, startSession, examSessionId, isLoadingQuizSession }) => {
        const currentSession = quizSessions.find((session) => {
          return session.id === paramExamSessionId;
        });
        if (examSessionId) {
          const path = QUIZ_SUB_ROUTES.SESSION.getPath(examId, examSessionId);
          history.push(path);
        }

        const { score: studentScore } = currentSession ?? {};

        return (
          <GradedExamResultView
            variant={variant}
            isPass={studentScore >= passingScore}
            passingScore={passingScore}
            remainingRound={maxAttempts - quizSessions.length}
            totalRound={maxAttempts}
            studentScore={studentScore}
            fullScore={fullScore}
            timeSpent={timeSpent}
            reports={quizSessions}
            onStartQuiz={async () => {
              await startSession();
            }}
            onSeeReport={handleSeeReport}
            onGoToNextSubsection={onEndQuiz}
            disableStartQuizButton={isLoadingQuizSession}
            openCourseReviewModal={openCourseReviewModal}
            isLastSubsectionInCourse={isLastSubsectionInCourse}
          />
        );
      }}
    </ClassroomQuizSession>
  );
};

export default GradedExamResult;
